export default class OrganizationAppMember {
  constructor(API) {
    this.api = API;
  }
  /* CRUD */
  async getOrganizationAppMember(orgID, memberID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'app/member/' + memberID;
    return await req.exec();
  }
  async removeOrganizationAppMember(orgID, memberID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'app/member/' + memberID;
    return await req.exec();
  }
  async updateOrganizationAppMember(orgID, memberID, updateObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'app/member/' + memberID;
    req.body = { ...updateObj };
    return await req.exec();
  }
  /* List */
  async getOrganizationAppMembers(orgID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/organization/' + (orgID ? orgID + '/' : '') + 'app/members';
    return await req.exec();
  }
  /* Search Operations */
  async searchOrganizationsAppMembersByTerm(searchTerm, filters) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/organizations/apps/members/search';
    req.body = { searchTerm, filter: filters };
    return await req.exec();
  }
}
